/* eslint-disable */
export default {
  account: '帐户',
  contact: '联系人',
  lead: '潜在客户',
  opportunity: '业务机会',
  case: '案例',
  chooseEntity: '请选择实体类型',
  create: '创建',
} as const;

// @key: @#@"account"@#@ @source: @#@"Account"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"lead"@#@ @source: @#@"Lead"@#@
// @key: @#@"opportunity"@#@ @source: @#@"Opportunity"@#@
// @key: @#@"case"@#@ @source: @#@"Case"@#@
// @key: @#@"chooseEntity"@#@ @source: @#@"Please select entity type"@#@
// @key: @#@"create"@#@ @source: @#@"Create"@#@
